import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import CustomButton from '../../../../Components/CustomButton'
import getStartedImg from '../../../../assets/images/get-started.png'

const GetStarted = () => {
    const navigate = useNavigate();
    return (
        <section className="get-started">
            <div className="appContainer">
                <Row className='align-items-center'>
                    <Col xs={12} lg={6} className='my-3 order-lg-1 order-2'>
                        <img src={getStartedImg} alt="get-started" className='img-fluid' />
                    </Col>
                    <Col xs={12} lg={6} className='my-3 order-lg-2 order-1'>
                        <h2>Get Started to find your match</h2>
                        <p className='grey-text fs-5'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsanLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsanLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsanLorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan</p>
                        <CustomButton className='mt-3' onClick={() => navigate('/about-us')}>Learn More</CustomButton>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default GetStarted
